// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__Mo9HB","text":"not-found_text__fGNZk"};